module.exports = {
      id: "libra-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#libra",
      toString: function () {
        return this.url;
      }
    }